import { render, staticRenderFns } from "./ForumsView.vue?vue&type=template&id=159b04e2&"
import script from "./ForumsView.vue?vue&type=script&lang=js&"
export * from "./ForumsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports